<template>
    <div>
        <v-row no-gutters>
            <v-col cols="6" class="pt-3 pl-3 pr-3">
                <v-tabs v-model="localSelectedWindow" fixed-tabs class="rounded-xl" color="primary">
                    <v-tab
                        value="commonStatements"
                        href="#commonStatements"
                        class="v-tab-rounded-0"
                        v-if="isAllowedToDeclaration"
                        >Déclarations courantes</v-tab
                    >
                    <v-tab
                        value="taxDeclarations"
                        href="#taxDeclarations"
                        class="v-tab-rounded-0"
                        v-if="isAllowedToBundles"
                        data-cy="TaxFormList-bundleTab"
                    >
                        Liasses fiscales
                    </v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters v-if="localSelectedWindow === 'commonStatements'">
                    <v-col :cols="isInAdmin ? 3 : 4" class="pt-3 pr-2 d-flex align-center">
                        <v-select
                            v-model="sortBy"
                            :items="sortByItems"
                            label="Tri par date de déclaration"
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col :cols="isInAdmin ? 3 : 4" class="pt-3 pr-2 d-flex align-center">
                        <v-select
                            v-model="declarationType"
                            :items="declarationTypeInformationTable"
                            item-title="text"
                            item-value="value"
                            label="Filtrer par type"
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="TaxFormList-declarationTypeSelector"
                        />
                    </v-col>
                    <v-col :cols="isInAdmin ? 3 : 4" class="pt-3 pr-2 d-flex align-center">
                        <v-select
                            v-model="declarationStatus"
                            :items="translateDeclarationStatusTable"
                            item-title="text"
                            item-value="value"
                            label="Filtrer par statut"
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="TaxFormList-declarationStatusSelector"
                        />
                    </v-col>
                    <v-col cols="4" v-if="isInAdmin" class="pt-3 pr-2 d-flex align-center">
                        <ossCompanySelector
                            v-model="companiesSelected"
                            :multiple="true"
                            :items="allAvailableCompanies"
                            :label="'Société'"
                            hide-details="auto"
                            data-cy="TaxFormList-companySelector"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else>
                    <v-col :cols="isInAdmin ? 4 : 6" class="pt-3 pr-2 d-flex align-center">
                        <v-select
                            v-model="bundleType"
                            :items="bundleTypeInformationTable"
                            item-title="text"
                            item-value="value"
                            label="Filtrer par type"
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="TaxFormList-bundleTypeSelector"
                        />
                    </v-col>
                    <v-col :cols="isInAdmin ? 4 : 6" class="pt-3 pr-2 d-flex align-center">
                        <v-select
                            v-model="bundleStatus"
                            :items="translateBundleStatusTable"
                            item-title="text"
                            item-value="value"
                            label="Filtre par statut"
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="TaxFormList-bundleStatusSelector"
                        />
                    </v-col>
                    <v-col cols="4" v-if="isInAdmin" class="pt-3 pr-2 d-flex align-center">
                        <ossCompanySelector
                            v-model="companiesSelected"
                            :multiple="true"
                            :items="allAvailableCompanies"
                            :label="'Société'"
                            hide-details="auto"
                            data-cy="TaxFormList-bundleCompanySelector"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-tabs-window v-model="localSelectedWindow">
            <v-tabs-window-item value="commonStatements">
                <v-row no-gutters class="px-4 d-flex align-center">
                    <v-col
                        cols="2"
                        v-if="!isInAdmin"
                        class="d-flex justify-space-around align-center"
                    >
                        <v-tooltip :disabled="!isNewDeclarationDisabled" location="end">
                            <template v-slot:activator="{ props }">
                                <!-- <v-btn-primary
                                    block
                                    @click="openTaxFormCreateDialog()"
                                    :disabled="isNewDeclarationDisabled"
                                    size="large"
                                    class="mt-2"
                                >
                                    Nouvelle déclaration
                                </v-btn-primary> -->
                                <v-btn-primary
                                    v-bind="props"
                                    block
                                    elevation="0"
                                    class="rounded-lg gradient mt-2"
                                    @click="openTaxFormCreateDialog2()"
                                    :disabled="isNewDeclarationDisabled"
                                    size="large"
                                >
                                    Nouvelle déclaration
                                </v-btn-primary>
                            </template>
                            <span v-html="tooltipMessage" />
                        </v-tooltip>
                        <ControlTVA class="ml-2"></ControlTVA>
                    </v-col>
                    <v-col cols="12" class="mt-2" fluid>
                        <v-data-table-server
                            v-model:items-per-page="declarationsPerPage"
                            v-model:page="declarationsPage"
                            :headers="declarationsTableHeaders"
                            :items="sortedDeclarations"
                            :items-length="totalDeclarations"
                            :items-per-page-options="[10, 20, 50, 100]"
                            item-key="id"
                            class="table"
                            fixed-header
                            height="65vh"
                            :hover="true"
                            prev-icon="$chevron-left"
                            next-icon="$chevron_right"
                            data-cy="TaxFormList-table"
                        >
                            <template v-slot:[`header.declarationDate`]>
                                <div>Date de<br />déclaration</div>
                            </template>
                            <template v-slot:[`header.createdAt`]>
                                <div>Date de<br />création</div>
                            </template>
                            <template v-slot:[`header.updatedAt`]>
                                <div>Date de dernière<br />modification</div>
                            </template>
                            <template v-slot:[`header.mtaeProof`]>
                                <div>Justificatif<br />EDI</div>
                            </template>
                            <template v-slot:[`header.checkbox`]>
                                <div class="d-flex align-center justify-start">
                                    <v-checkbox
                                        color="primary"
                                        :indeterminate="
                                            !!declarationsSelected.length &&
                                            declarationsSelected.length !==
                                                filteredDeclarations.length
                                        "
                                        class="pa-0 ma-0 mr-1 pl-1"
                                        :ripple="false"
                                        hide-details
                                        :disabled="!filteredDeclarations.length"
                                        @click.stop="selectAllDeclarations()"
                                        :model-value="
                                            filteredDeclarations.length !== 0 &&
                                            declarationsSelected.length ===
                                                filteredDeclarations.length
                                        "
                                    />
                                    <v-menu offset-y v-if="isAccountingUser">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                v-bind="props"
                                                class="ml-9"
                                                icon="$dots_vertical"
                                            >
                                            </v-btn-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="isDeleteDeclarationDisable"
                                                @click="dialogDeleteSelectedDeclaration = true"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template #append>
                                                    <v-icon
                                                        :disabled="isDeleteDeclarationDisable"
                                                        size="small"
                                                        >$delete</v-icon
                                                    >
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </template>
                            <template v-slot:no-data>Aucune déclaration</template>
                            <template v-slot:item="{ item }">
                                <tr @click="openDeclaration(item)">
                                    <td class="d-flex justify-start align-center">
                                        <v-checkbox
                                            color="primary"
                                            hide-details
                                            class="mt-0 pt-0 ml-1"
                                            @click.stop="selectDeclaration(item.id)"
                                            :model-value="declarationsSelected.includes(item.id)"
                                        />
                                    </td>
                                    <td v-if="isInAdmin" class="text-left">
                                        <b
                                            :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-company`"
                                            >{{ item.company.name }}</b
                                        >
                                    </td>
                                    <td :class="isInAdmin ? 'text-center' : 'text-left'">
                                        <b
                                            id="cerfaNumber"
                                            :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-cerfaNumber`"
                                            >{{ item.cerfaNumber }}</b
                                        >
                                    </td>
                                    <td class="text-center wrapper">
                                        <p
                                            class="line-clamp-2"
                                            :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-name`"
                                        >
                                            {{ item.name }}
                                        </p>
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-period`"
                                    >
                                        {{ item.period }}
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-year`"
                                    >
                                        {{ item.year }}
                                    </td>
                                    <td
                                        class="text-right"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-amountDeclared`"
                                    >
                                        <template v-if="item.amountDeclaredToDisplay">
                                            {{ item.amountDeclaredToDisplay }}
                                        </template>
                                        <template v-else>
                                            <v-icon color="primary" size="x-large">$dot</v-icon>
                                        </template>
                                    </td>
                                    <td
                                        class="text-right"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-amountPaid`"
                                    >
                                        <template v-if="item.amountPaid">
                                            {{ item.amountPaid }}
                                        </template>
                                        <template v-else>
                                            <v-icon color="primary" size="x-large">$dot</v-icon>
                                        </template>
                                    </td>
                                    <td class="text-center wrapper">
                                        <span
                                            :class="
                                                item.status === 'ERROR'
                                                    ? 'text-red line-clamp-2'
                                                    : 'line-clamp-2'
                                            "
                                            :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-status`"
                                        >
                                            {{ item.translateStatus }}
                                        </span>
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-declarationDate`"
                                    >
                                        <template v-if="item.date">
                                            {{ formatDateWithSlash(item.date) }}
                                        </template>
                                        <template v-else>
                                            <v-icon color="primary" size="x-large">$dot</v-icon>
                                        </template>
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-creationDate`"
                                    >
                                        {{
                                            item.createdAt
                                                ? formatDateWithSlash(item.createdAt)
                                                : ""
                                        }}
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-LastUpdateDate`"
                                    >
                                        {{
                                            item.updatedAt
                                                ? formatDateWithSlash(item.updatedAt)
                                                : ""
                                        }}
                                    </td>
                                    <td>
                                        <TaxFormEDIReport
                                            :taxFormId="item.id"
                                            @mtaeProofEvent="mtaeProof"
                                            :isDeclaration="true"
                                            :data-cy="`declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-ediProof`"
                                            :companyFromTaxFormListForAdminMode="item.company"
                                            :accountingPeriodFromTaxFormListForAdminMode="
                                                isInAdmin && item.accountingPeriod
                                            "
                                        />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table-server>
                    </v-col>
                </v-row>
                <oss-dialog
                    v-if="dialogDeleteSelectedDeclaration"
                    v-model="dialogDeleteSelectedDeclaration"
                    title="Suppression"
                    @valid="deleteDeclarations()"
                >
                    <div class="text-center" style="width: 750px">
                        <b>
                            Voulez-vous supprimer
                            {{
                                declarationsSelected.length === 1
                                    ? "la"
                                    : declarationsSelected.length
                            }}
                            déclaration{{ declarationsSelected.length === 1 ? "" : "s" }}
                            ?
                        </b>
                        <br /><br />
                        <b
                            >Attention, la suppression d'une déclaration entraîne la suppression de
                            l'écriture d'OD et les lettrages afférents le cas échéant.</b
                        >
                    </div>
                </oss-dialog>
                <oss-dialog
                    v-model="dialogCreateTaxForm2"
                    :title="
                        newDeclarationStep2 === 'prefilterSelection'
                            ? 'Sélectionnez le type de formulaire'
                            : newDeclarationStep2 === 'declarationSelection'
                              ? 'Sélectionnez le formulaire à remplir'
                              : 'Période de déclaration'
                    "
                    @previous="goToPreviousTab()"
                    :previous-display="newDeclarationStep2 !== 'prefilterSelection'"
                    @valid="validNewDeclarationDialog2()"
                    :valid-disabled="isNewDeclarationDialogValidDisabled"
                    :hideValid="
                        ['prefilterSelection', 'declarationSelection'].includes(newDeclarationStep2)
                    "
                    @close="resetNewDeclarationDialog2()"
                >
                    <div style="width: 750px">
                        <v-window v-model="newDeclarationStep2">
                            <v-window-item value="prefilterSelection">
                                <v-list>
                                    <v-list-item
                                        v-if="
                                            companyDeclarationConditions.find((condition: string) =>
                                                condition.includes('Tva'),
                                            )
                                        "
                                        @click="prefilterForms('Tva')"
                                        title="TVA"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="
                                            companyDeclarationConditions.includes(
                                                'isRegimeFiscalIS',
                                            )
                                        "
                                        @click="prefilterForms('isRegimeFiscalIS')"
                                        title="IS"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="
                                            companyDeclarationConditions.includes('isCVAESubject')
                                        "
                                        @click="prefilterForms('isCVAESubject')"
                                        title="CVAE"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="
                                            companyDeclarationConditions.includes('isDAS2Subject')
                                        "
                                        @click="prefilterForms('isDAS2Subject')"
                                        title="DAS2"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="companyDeclarationConditions.includes('isRCMSubject')"
                                        @click="prefilterForms('isRCMSubject')"
                                        title="RCM"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="companyDeclarationConditions.includes('isIFUSubject')"
                                        @click="prefilterForms('isIFUSubject')"
                                        title="IFU"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item>
                                    <!-- <v-list-item
                                        @click="prefilterForms('3030')"
                                        title="Conformité fiscale"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        "
                                    >
                                        <template #append>
                                            <v-icon size="small">$fa-chevron-right</v-icon>
                                        </template>
                                    </v-list-item> -->
                                </v-list>
                            </v-window-item>
                            <v-window-item value="declarationSelection">
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        class="mr-2"
                                        v-if="
                                            selectedCompany &&
                                            selectedCompany.vatSystem &&
                                            !isNotSubjectToVAT(selectedCompany.vatSystem) &&
                                            prefilter === 'Tva'
                                        "
                                    >
                                        <!-- SPECIFIC -->
                                        <!-- CA3 + CA12 -->
                                        <v-list-item
                                            ripple
                                            @click="
                                                newDeclarationStep2 = 'vatAutoDatesSelection';
                                                selectedDeclarationForm.cerfaNumber =
                                                    companyDeclarationConditions.includes(
                                                        'isTvaRegimeReel',
                                                    )
                                                        ? '3310CA3'
                                                        : companyDeclarationConditions.includes(
                                                                'isTvaRegimeAgricole',
                                                            )
                                                          ? '3517BCA12'
                                                          : '3517SCA12';
                                            "
                                            :class="
                                                !$vuetify.display.mobile
                                                    ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                    : 'my-2 px-2 oss-list-item rounded-xl border'
                                            "
                                        >
                                            <v-list-item-title
                                                >Déclaration de TVA automatique</v-list-item-title
                                            >
                                            <!-- SPECIFIC -->
                                            <!-- CA3 + CA12 -->
                                            <v-list-item-subtitle>{{
                                                companyDeclarationConditions.includes(
                                                    "isTvaRegimeReel",
                                                )
                                                    ? "3310CA3"
                                                    : companyDeclarationConditions.includes(
                                                            "isTvaRegimeAgricole",
                                                        )
                                                      ? "3517BCA12"
                                                      : "3517SCA12"
                                            }}</v-list-item-subtitle>
                                            <template #append>
                                                <v-icon
                                                    :disabled="isDeleteBundleDisable"
                                                    size="small"
                                                    >$fa-chevron-right</v-icon
                                                >
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            ripple
                                            @click="
                                                newDeclarationStep2 = 'vatAssistDatesSelection';
                                                selectedDeclarationForm.cerfaNumber =
                                                    companyDeclarationConditions.includes(
                                                        'isTvaRegimeReel',
                                                    )
                                                        ? '3310CA3'
                                                        : companyDeclarationConditions.includes(
                                                                'isTvaRegimeAgricole',
                                                            )
                                                          ? '3517BCA12'
                                                          : '3517SCA12';
                                            "
                                            :class="
                                                !$vuetify.display.mobile
                                                    ? 'my-2 py-3 mb-5 oss-list-item rounded-xl border'
                                                    : 'my-2 mb-5 px-2 oss-list-item rounded-xl border'
                                            "
                                        >
                                            <div>
                                                <v-list-item-title
                                                    >Assistant à la déclaration de
                                                    TVA</v-list-item-title
                                                >
                                                <!-- SPECIFIC -->
                                                <!-- CA3 + CA12 -->
                                                <v-list-item-subtitle>{{
                                                    companyDeclarationConditions.includes(
                                                        "isTvaRegimeReel",
                                                    )
                                                        ? "3310CA3"
                                                        : companyDeclarationConditions.includes(
                                                                "isTvaRegimeAgricole",
                                                            )
                                                          ? "3517BCA12"
                                                          : "3517SCA12"
                                                }}</v-list-item-subtitle>
                                            </div>
                                            <template #append>
                                                <v-icon
                                                    :disabled="isDeleteBundleDisable"
                                                    size="small"
                                                    >$fa-chevron-right</v-icon
                                                >
                                            </template>
                                        </v-list-item>
                                        <v-divider class="mb-4" />
                                    </v-col>
                                    <!-- SPECIFIC -->
                                    <!-- DAS2 -->
                                    <v-col
                                        cols="12"
                                        class="mr-2"
                                        v-if="prefilter === 'isDAS2Subject'"
                                    >
                                        <v-list-item
                                            ripple
                                            @click="
                                                newDeclarationStep2 = 'declarationDatesSelection';
                                                selectedDeclarationForm.cerfaNumber = 'DAS2';
                                            "
                                            :class="
                                                !$vuetify.display.mobile
                                                    ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                    : 'my-2 px-2 oss-list-item rounded-xl border'
                                            "
                                        >
                                            <v-list-item-title>Assistant DAS2</v-list-item-title>
                                            <v-list-item-subtitle>DAS2</v-list-item-subtitle>
                                            <template #append>
                                                <v-icon size="small">$fa-chevron-right</v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-col>
                                    <v-col v-else cols="12" class="mr-2">
                                        <v-col
                                            v-if="!sortedDeclarationTypes2.length"
                                            cols="12"
                                            class="d-flex"
                                            style="height: 432px"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                size="28"
                                                class="mx-auto"
                                                color="primary"
                                            />
                                        </v-col>
                                        <v-virtual-scroll
                                            v-else
                                            :items="sortedDeclarationTypes2"
                                            item-height="66"
                                            height="432"
                                        >
                                            <template v-slot="{ item }">
                                                <v-list-item
                                                    :key="item.name"
                                                    ripple
                                                    @click="
                                                        selectedDeclarationForm = item;
                                                        newDeclarationStep2 =
                                                            'declarationDatesSelection';
                                                    "
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                            : 'my-2 px-2 oss-list-item rounded-xl border'
                                                    "
                                                >
                                                    <v-list-item-title>{{
                                                        item.name
                                                    }}</v-list-item-title>
                                                    <v-list-item-subtitle>{{
                                                        item.cerfaNumber
                                                    }}</v-list-item-subtitle>
                                                    <template #append>
                                                        <v-icon
                                                            :disabled="isDeleteBundleDisable"
                                                            size="small"
                                                            >$fa-chevron-right</v-icon
                                                        >
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-virtual-scroll>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="declarationDatesSelection">
                                <!-- SPECIFIC -->
                                <!-- deposit period selection -->
                                <v-row
                                    no-gutters
                                    v-if="
                                        ['1329AC', '2571', '3514', '3525BIS'].includes(
                                            selectedDeclarationForm.cerfaNumber,
                                        )
                                    "
                                    class="my-5 d-flex justify-center align-center"
                                >
                                    <v-col cols="5" class="d-flex justify-end align-center">
                                        <h3>Sélectionnez la période de l'acompte :</h3>
                                    </v-col>
                                    <v-col cols="3" class="ml-2 d-flex justify-start align-center">
                                        <v-select-filled
                                            :items="periodSelectorItems"
                                            item-title="text"
                                            item-value="value"
                                            v-model="depositPeriod"
                                            dense
                                            label="Sélectionner"
                                            outlined
                                            hide-details="auto"
                                        />
                                    </v-col>
                                    <v-col cols="4" />
                                </v-row>
                                <!-- SPECIFIC -->
                                <!-- 3310CA3 -->
                                <!-- period selection -->
                                <v-row
                                    no-gutters
                                    v-else-if="
                                        ['3310CA3'].includes(selectedDeclarationForm.cerfaNumber)
                                    "
                                    class="my-5 d-flex justify-center align-center"
                                >
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-select-filled
                                            :items="CA3Periods"
                                            item-title="text"
                                            item-value="value"
                                            v-model="selectedCA3Period"
                                            dense
                                            label="Période"
                                            outlined
                                            hide-details="auto"
                                        />
                                    </v-col>
                                </v-row>
                                <!-- SPECIFIC -->
                                <!-- dates selection -->
                                <v-row
                                    no-gutters
                                    v-else-if="
                                        ['3519', '2561', '2777', '3517DDR'].includes(
                                            selectedDeclarationForm.cerfaNumber,
                                        )
                                    "
                                    class="my-5 d-flex justify-center align-center"
                                >
                                    <v-col cols="12">
                                        <v-row no-gutters class="mt-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b>
                                                    Indiquez le premier jour de la période à
                                                    déclarer :
                                                </b>
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationStartDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mt-1 mb-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b>
                                                    Indiquez le dernier jour de la période à
                                                    déclarer :
                                                </b>
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationEndDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <!-- SPECIFIC -->
                                <!-- period check -->
                                <v-row
                                    no-gutters
                                    v-else-if="
                                        [
                                            '3517SCA12',
                                            '3517BCA12',
                                            '2572',
                                            '1329DEF',
                                            '3030SD',
                                            '2573',
                                            'DAS2',
                                        ].includes(selectedDeclarationForm.cerfaNumber)
                                    "
                                    class="my-5"
                                >
                                    <v-col cols="12" class="d-flex justify-center align-center">
                                        <h3>Vérifiez la période de déclaration :</h3>
                                        <p style="margin-bottom: 0px; margin-left: 5px">
                                            du
                                            {{ formatDateWithSlash(newDeclarationStartDate) }} au
                                            {{ formatDateWithSlash(newDeclarationEndDate) }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <!-- auto vat -->
                            <v-window-item value="vatAutoDatesSelection">
                                <!-- SPECIFIC -->
                                <!-- 3310CA3 -->
                                <!-- period selection -->
                                <v-row
                                    no-gutters
                                    v-if="['3310CA3'].includes(selectedDeclarationForm.cerfaNumber)"
                                    class="my-5 d-flex justify-center align-center"
                                >
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-select-filled
                                            :items="CA3Periods"
                                            item-title="text"
                                            item-value="value"
                                            v-model="selectedCA3Period"
                                            dense
                                            label="Période"
                                            outlined
                                            hide-details="auto"
                                        />
                                    </v-col>
                                </v-row>
                                <!-- dates selection -->
                                <v-row no-gutters v-else class="my-5">
                                    <v-col cols="12">
                                        <v-row no-gutters class="mt-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b>
                                                    Indiquez le premier jour de la période à
                                                    déclarer :
                                                </b>
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationStartDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mt-1 mb-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b>
                                                    Indiquez le dernier jour de la période à
                                                    déclarer :
                                                </b>
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationEndDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <!-- assist vat -->
                            <v-window-item value="vatAssistDatesSelection">
                                <!-- SPECIFIC -->
                                <!-- 3310CA3 -->
                                <!-- period selection -->
                                <v-row
                                    no-gutters
                                    v-if="['3310CA3'].includes(selectedDeclarationForm.cerfaNumber)"
                                    class="my-5 d-flex justify-center align-center"
                                >
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-select-filled
                                            :items="CA3Periods"
                                            item-title="text"
                                            item-value="value"
                                            v-model="selectedCA3Period"
                                            dense
                                            label="Période"
                                            outlined
                                            hide-details="auto"
                                        />
                                    </v-col>
                                </v-row>
                                <!-- dates selection -->
                                <v-row no-gutters v-else class="my-5">
                                    <v-col cols="12">
                                        <v-row no-gutters class="mt-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b
                                                    >Indiquez le premier jour de la période à
                                                    déclarer :</b
                                                >
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationStartDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mt-1 mb-5 d-flex justify-center">
                                            <v-col cols="6" class="d-flex align-center">
                                                <b
                                                    >Indiquez le dernier jour de la période à
                                                    déclarer :</b
                                                >
                                            </v-col>
                                            <v-col cols="3" class="d-flex justify-center">
                                                <oss-date-picker-filled
                                                    v-model="newDeclarationEndDate"
                                                    hide-details
                                                    :textFieldReadOnly="false"
                                                    :minDate="accountingPeriodStart"
                                                    :maxDate="accountingPeriodEnd"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>
                    </div>
                </oss-dialog>
            </v-tabs-window-item>
            <v-tabs-window-item key="taxDeclarations" value="taxDeclarations">
                <v-row no-gutters class="px-4">
                    <v-col
                        cols="2"
                        class="d-flex justify-space-around"
                        vertical-align="center"
                        v-if="selectedCompany && !isInAdmin && !isAccountingCustomer"
                    >
                        <v-btn-primary
                            block
                            elevation="0"
                            class="rounded-lg gradient mt-2"
                            :disabled="disableNewBundleCreation"
                            @click="newBundleAction()"
                            size="large"
                            data-cy="TaxFormTable-add"
                        >
                            Nouvelle Liasse
                        </v-btn-primary>
                    </v-col>
                    <v-col cols="12" class="mt-2" fluid>
                        <v-data-table-server
                            v-model:items-per-page="bundlesPerPage"
                            v-model:page="bundlesPage"
                            :items-length="totalBundles"
                            :headers="bundlesTableHeaders"
                            :items="filteredBundles"
                            item-key="id"
                            class="table rounded-xl"
                            fixed-header
                            height="65vh"
                            :hover="true"
                            prev-icon="$chevron-left"
                            next-icon="$chevron_right"
                            data-cy="taxFormList-table"
                        >
                            <template v-slot:[`header.checkbox`]>
                                <div class="d-flex align-center justify-start">
                                    <v-checkbox
                                        color="primary"
                                        :indeterminate="
                                            !!bundlesSelected.length &&
                                            bundlesSelected.length !== filteredBundles.length
                                        "
                                        class="pa-0 ma-0 mr-1 pl-1"
                                        :ripple="false"
                                        :disabled="!filteredBundles.length"
                                        hide-details
                                        @click.stop="selectAllBundles()"
                                        :model-value="
                                            filteredBundles.length !== 0 &&
                                            bundlesSelected.length === filteredBundles.length
                                        "
                                    />
                                    <v-menu offset-y v-if="isAccountingUser">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon
                                                v-bind="props"
                                                class="ml-9"
                                                icon="$dots_vertical"
                                            >
                                            </v-btn-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="isDeleteBundleDisable"
                                                @click="dialogDeleteSelectedBundles = true"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template #append>
                                                    <v-icon
                                                        :disabled="isDeleteBundleDisable"
                                                        size="small"
                                                        >$delete</v-icon
                                                    >
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </template>
                            <template v-slot:no-data>Aucune liasse</template>
                            <template v-slot:item="{ item }">
                                <tr @click="openDeclaration(item)">
                                    <td class="d-flex justify-start align-center">
                                        <v-checkbox
                                            color="primary"
                                            :v-model="bundlesSelected"
                                            hide-details
                                            class="mt-0 pt-0 ml-1"
                                            @click.stop="selectBundle(item.id)"
                                            :model-value="bundlesSelected.includes(item.id)"
                                        />
                                    </td>
                                    <!-- Affichage -->
                                    <td class="text-left" v-if="isInAdmin">
                                        <b
                                            :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-company`"
                                            >{{ item.company.name }}</b
                                        >
                                    </td>
                                    <td :class="isInAdmin ? 'text-center' : 'text-left'">
                                        <b
                                            :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-title`"
                                            >{{ item.title }}</b
                                        >
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-taxSystem`"
                                    >
                                        {{ item.taxSystem }}
                                    </td>
                                    <td class="text-center">
                                        <span
                                            v-if="item.accountingPeriod"
                                            :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-accountingPeriod`"
                                        >
                                            {{ formatDateWithSlash(item.accountingPeriod.start) }} -
                                            {{ formatDateWithSlash(item.accountingPeriod.end) }}
                                        </span>
                                    </td>
                                    <td class="text-center wrapper">
                                        <span
                                            :class="
                                                item.status === 'ERROR'
                                                    ? 'text-red line-clamp-2'
                                                    : 'line-clamp-2'
                                            "
                                            :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-status`"
                                        >
                                            {{ item.translateStatus }}
                                        </span>
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-sendDate`"
                                    >
                                        {{ item.date ? formatDateWithSlash(item.date) : "" }}
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-creationDate`"
                                    >
                                        {{
                                            item.createdAt
                                                ? formatDateWithSlash(item.createdAt)
                                                : ""
                                        }}
                                    </td>
                                    <td
                                        class="text-center"
                                        :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-lastUpdateDate`"
                                    >
                                        {{
                                            item.updatedAt
                                                ? formatDateWithSlash(item.updatedAt)
                                                : ""
                                        }}
                                    </td>
                                    <td>
                                        <TaxFormEDIReport
                                            :taxFormId="item.id"
                                            @mtaeProofEvent="mtaeProof"
                                            :data-cy="`bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-ediProof`"
                                            :companyFromTaxFormListForAdminMode="item.company"
                                            :accountingPeriodFromTaxFormListForAdminMode="
                                                isInAdmin && item.accountingPeriod
                                            "
                                        />
                                    </td>
                                </tr>
                            </template>
                        </v-data-table-server>
                    </v-col>
                </v-row>
                <oss-dialog
                    v-model="bundleInformationDialog"
                    v-if="bundleInformationDialog"
                    title="Information"
                    valid-title="Fermer"
                    @valid="bundleInformationDialog = false"
                    @close="bundleInformationDialog = false"
                >
                    <div style="width: 750px">
                        <b class="text-center my-5">
                            Seule la liasse fiscale 2035 concernant les BNC est disponible. bobbee
                            met tout en oeuvre pour vous proposer très bientôt les autres liasses
                            fiscales.
                        </b>
                    </div>
                </oss-dialog>
                <oss-dialog
                    v-model="manyBundlesOnSamePeriodDialog"
                    v-if="manyBundlesOnSamePeriodDialog"
                    title="Attention"
                    valid-title="Valider"
                    @valid="
                        manyBundlesOnSamePeriodDialog = false;
                        newBundle();
                    "
                    @close="manyBundlesOnSamePeriodDialog = false"
                >
                    <div style="width: 750px" class="d-flex justify-center align-center">
                        <b class="my-5">
                            Il existe déjà une liasse fiscale pour cette période, souhaitez-vous
                            vraiment en générer une nouvelle ?
                        </b>
                    </div>
                </oss-dialog>
                <oss-dialog
                    v-model="dialogDeleteSelectedBundles"
                    :title="
                        bundlesSelected.length > 1
                            ? 'Supprimer des liasses'
                            : 'Supprimer une liasse'
                    "
                    @valid="deleteBundles()"
                >
                    <div class="text-center" style="width: 750px">
                        <b>
                            Voulez-vous supprimer {{ bundlesSelected.length }} liasse{{
                                bundlesSelected.length === 1 ? "" : "s"
                            }}
                            ?
                        </b>
                    </div>
                </oss-dialog>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts">
import { Apollo, State2Way } from "@/decorators";
import COMPANIES from "@/graphql/company/CompaniesFilter.gql";
import _ from "lodash";
// import { Offer_type } from "@/types/offer.types";
import DECLARATIONS from "@/graphql/declaration/Declarations.gql";
import DELETE_BUNDLE from "@/graphql/declaration/DeleteBundle.gql";
import DELETE_DECLARATION from "@/graphql/declaration/DeleteDeclaration.gql";
import DECLARATIONS_FORM_LIST from "@/graphql/declarationForm/DeclarationsFormList.gql";
import { getPaymentsFromXml, storeVatItems } from "@/services/declaration/declarationServices";
import { setCurrentCompany } from "@/services/userServices";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import gql from "graphql-tag";
import moment from "moment-timezone";
import { orderBy, uniqBy } from "lodash";
import { convertCerfaNumber } from "../../../../backend/src/common/declaration/declarationServices";
import DECLARATIONS_LIST from "../../../../backend/src/common/declaration/formList/Dec.json";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import TaxFormEDIReport from "./TaxFormEDIReport.vue";
// import getEnv from "@/env";
import { User } from "@/store/store";
import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";
import Spec from "../../../../backend/src/common/specs/Spec";
import ControlTVA from "../controlTVA/ControlTVA.vue";
import ossCompanySelector from "../ossComponents/ossCompanySelector.vue";
import { checkAccessRights } from "@/services/accessRightServices";

// const env = getEnv();

class Declaration {
    id: string;
    status: string;
    date: string;
    startDate: string;
    endDate: string;
    form: any;
    company: any;
    accountingPeriod: any;
    mtaeStatus: string;
    amountDeclared: number;
    data: any;
    createdAt: Date;
    updatedAt: Date;
    bundleSheets: any[]; // for bundle
    sheets: any[]; // for common declaration
    constructor() {}

    get title() {
        if (this.bundleSheets.length) {
            // if (this.bundleSheets?.some((bs) => bs.form.cerfaNumber === "2065")) {
            //     return "Liasse fiscale - 2065";
            // }
            // if (this.bundleSheets?.some((bs) => bs.form.cerfaNumber === "2031")) {
            //     return "Liasse fiscale - 2031";
            // }
            // if (this.bundleSheets?.some((bs) => bs.form.cerfaNumber.startsWith("2072"))) {
            //     return "Liasse fiscale - 2072";
            // }
            // if (this.bundleSheets?.some((bs) => bs.form.cerfaNumber === "2035")) {
            //     return "Liasse fiscale - 2035";
            // }
            // Normal IS - "régime réel normal en matière de BIC et d'IS"
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber?.startsWith("2050"))) {
                return "Liasse fiscale - 2050";
            }
            // Simplifié IS - "entreprises soumises à l'IS ou au BIC au régime réel simplifié"
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber?.startsWith("2033"))) {
                return "Liasse fiscale - 2033";
            }
            // SCI IR - "sociétés immobilières non soumises à l'impôt sur les sociétés"
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber?.startsWith("2072"))) {
                return "Liasse fiscale - 2072";
            }
            // BNC - "bénéfices non commerciaux"
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber?.startsWith("2035"))) {
                return "Liasse fiscale - 2035";
            }
            // BA Simplifié IS
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber?.startsWith("2139"))) {
                return "Liasse fiscale - 2139";
            }
            debugger;
        }
        return this.name || "";
    }

    get taxSystem() {
        if (this.bundleSheets?.length) {
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber === "2065")) {
                return "BIC - IS";
            }
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber === "2031")) {
                return "BIC - IR";
            }
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber.startsWith("2072"))) {
                return "SCI";
            }
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber === "2035")) {
                return "BNC";
            }
            if (this.bundleSheets?.some((bs) => bs.form?.cerfaNumber.startsWith("2139"))) {
                return "BA simplifié";
            }
            debugger;
        }
        debugger;
        return "XXXX";
    }

    get cerfaNumber() {
        if (this.form?.cerfaNumber) {
            return this.form.cerfaNumber;
        }
        if (this.bundleSheets?.length) {
            return this.bundleSheets[0].form?.cerfaNumber || "XXXX";
        }
        if (this.sheets?.length) {
            const allCerfaNumbers: string[] = this.sheets
                .map((sheet) => sheet.form?.cerfaNumber)
                .filter((cerfa) => cerfa); // avoid to handle specific cases (undefined, null)
            for (const cerfa of allCerfaNumbers) {
                const convertedCerfa: string = convertCerfaNumber(cerfa);
                if (convertedCerfa !== cerfa) {
                    // specific prefix found
                    return convertedCerfa;
                }
            }
            // cerfaNumber is not specific or does not exist
            return allCerfaNumbers[0] || "XXXX";
        }
        debugger;
        return "XXXX";
    }

    get name() {
        if (this.form?.cerfaNumber) {
            return this.form.name;
        }
        if (this.bundleSheets?.length) {
            return this.bundleSheets[0].name;
        }
        if (this.data?.assistVatMode) {
            return "Assistant TVA";
        }
        if (this.data?.autoVatMode) {
            return "TVA automatique";
        }
        if (this.sheets?.length) {
            const name: string = this.transformCerfaName(this.sheets[0]?.form?.name) || "XXXX";
            // SPECIFIC
            // 3310CA3
            if (
                name === "Déclaration de TVA et taxes assimilées - régime réel normal ou mini réel"
            ) {
                return "TVA - Déclaration mensuelle et trimestrielle";
            }
            return name;
        }
        debugger;
        return "XXXX";
    }

    get year() {
        if (this.form?.year) {
            return this.form.year;
        }
        if (this.sheets?.length) {
            return this.sheets[0]?.form?.year || "XXXX";
        }
        debugger;
        return "XXXX";
    }

    // SPECIFIC
    get period() {
        if (this.accountingPeriod) {
            if (
                [
                    "2572",
                    "2572SD",
                    "2573",
                    "3517SCA12",
                    "3517BCA12",
                    "CVAE",
                    "1329DEF",
                    "1330CVAE",
                ].includes(this.cerfaNumber)
            ) {
                return (
                    moment(this.accountingPeriod.start).format("DD/MM/YYYY") +
                    " - " +
                    moment(this.accountingPeriod.end).format("DD/MM/YYYY")
                );
            }
        }
        if (this.endDate) {
            if (this.cerfaNumber === "2561") {
                return (
                    moment(this.startDate).format("DD/MM/YYYY") +
                    " - " +
                    moment(this.endDate).format("DD/MM/YYYY")
                );
            }
            // "Janvier 2024" style
            const endDate: Date = new Date(this.endDate);
            const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat("fr-FR", {
                month: "long",
                year: "numeric",
            });
            const monthYear: string = formatter.format(endDate);
            const formattedPeriod: string = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);
            return formattedPeriod;
        }
        debugger;
        return "XXXX";
    }

    get translateStatus() {
        switch (this.status) {
            case "EDITION":
                return "En cours d'édition";
            case "SENT":
                if (!this.mtaeStatus) {
                    return "Validée sans envoi";
                }
                if (this.mtaeStatus !== "OK") {
                    return this.mtaeStatus;
                }
                return "Envoyée";
            case "ERROR":
                return this.mtaeStatus;
            default:
                return "Inconnu";
        }
    }

    get amountPaid(): string {
        const xml = this.data?.file;
        if (this.status === "SENT" && xml) {
            const amount = getPaymentsFromXml(xml).amountPaid.toString();
            if (+amount > 0) {
                return newCommonFormatCurrency(amount, undefined);
            }
        }
        return null;
    }

    set amountPaid(value) {
        // do nothing
    }

    get amountDeclaredToDisplay(): string {
        // show negative value if it is a surplus or a refund request
        if (this.status === "EDITION" || this.translateStatus === "Validée sans envoi") {
            return null;
        }
        if (this.sheets?.length) {
            let amount: number = 0;
            // SPECIFIC
            switch (this.cerfaNumber) {
                case "3310CA3": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "3310CA32");
                    const spec = sheet?.data?.["JC"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "3514": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "3514");
                    const spec = sheet?.data?.["IC"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "3517SCA12": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "3517SC4");
                    const spec = sheet?.data?.["RC"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "3517BCA12": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "3517BCA3");
                    const spec = sheet?.data?.["MC"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "2777": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "27777");
                    const spec = sheet?.data?.["EB"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "2572": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "25723");
                    const spec = sheet?.data?.["EB"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "1329DEF": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "1329DEF2");
                    const spec = sheet?.data?.["JE"];
                    if (spec) {
                        amount = +Spec.getValue(spec);
                    }
                    break;
                }
                case "DAS2": {
                    const sheet = this.sheets?.find((s) => s.form?.cerfaNumber === "DAS2T");
                    amount +=
                        +Spec.getValue(sheet?.data?.TA) ||
                        0 + +Spec.getValue(sheet?.data?.TA_02) ||
                        0 + +Spec.getValue(sheet?.data?.TA_03) ||
                        0 + +Spec.getValue(sheet?.data?.TA_04) ||
                        0 + +Spec.getValue(sheet?.data?.TA_05) ||
                        0 + +Spec.getValue(sheet?.data?.TA_06) ||
                        0 + +Spec.getValue(sheet?.data?.TA_07) ||
                        0 + +Spec.getValue(sheet?.data?.TA_08) ||
                        0 + +Spec.getValue(sheet?.data?.TC) ||
                        0 + +Spec.getValue(sheet?.data?.TB) ||
                        0 + +Spec.getValue(sheet?.data?.TD) ||
                        0;
                    break;
                }
                default:
                    break;
            }
            if (amount > 0) {
                return newCommonFormatCurrency(-this.amountDeclared, undefined);
            }
        }
        return newCommonFormatCurrency(this.amountDeclared, undefined);
    }

    async open($router, formatDateWithDash, $store) {
        if (this.bundleSheets?.length) {
            $router.push({ name: "taxForm2", params: { id: this.id } });
        } else if (this.sheets?.length) {
            if (this.data?.assistVatMode) {
                // store vat items to use in assist vat
                storeVatItems(
                    this.data.autoVatItems,
                    this.data.assistVatItems,
                    this.data.previousVatCredit,
                    $store,
                );
                $router.push({
                    name: "vatCalculationAssist",
                    params: {
                        startDate: formatDateWithDash(this.startDate),
                        endDate: formatDateWithDash(this.endDate),
                        companyId: this.company?.id,
                        cerfaNumber: this.cerfaNumber,
                        version: "new",
                        declarationId: this.id,
                    },
                });
            } else if (this.data?.autoVatMode) {
                // store vat items to use in auto vat
                storeVatItems(
                    this.data.autoVatItems,
                    this.data.assistVatItems,
                    this.data.previousVatCredit,
                    $store,
                );
                $router.push({
                    name: "vatDeclarationAuto",
                    params: {
                        startDate: formatDateWithDash(this.startDate),
                        endDate: formatDateWithDash(this.endDate),
                        companyId: this.company?.id,
                        cerfaNumber: this.cerfaNumber,
                        version: "new",
                        declarationId: this.id,
                    },
                });
            } else {
                $router.push({ name: "declaration2", params: { id: this.id } });
            }
        } else {
            $router.push({ name: "declaration", params: { decId: this.id } });
        }
    }

    transformCerfaName(str: string) {
        return (
            str
                ?.replace(/^.*?:\s*/, "")
                .replace(/\s*\(.*?\)\s*/g, "")
                .trim() || "XXXX"
        );
    }
}

@Component({
    components: {
        TaxFormEDIReport,
        ossCompanySelector,
        ControlTVA,
    },
    methods: {
        isNotSubjectToVAT,
    },
    emits: ["mtaeProofEvent"],
})
export class TaxFormList extends Vue {
    @State2Way("updateDeclarationPagination", "declarationFilter.pagination")
    pagination!: any;

    @Prop() value;

    @Prop({ default: "commonStatements" }) selectedWindow: "commonStatements" | "taxDeclarations";
    // selectedWindow: "commonStatements" | "taxDeclarations" = "commonStatements";
    localSelectedWindow: "commonStatements" | "taxDeclarations" = "commonStatements";
    newDeclarationStep: string = "declarationSelection";
    newDeclarationStep2: string = "prefilterSelection";

    selectedDeclarationForm: any = {
        id: "",
        cerfaNumber: "",
        name: "",
        type: "",
    };

    bundleInformationDialog: boolean = false;

    manyBundlesOnSamePeriodDialog: boolean = false;

    dialogDeleteSelectedDeclaration: boolean = false;
    dialogDeleteSelectedBundles: boolean = false;

    dialogCreateVatAuto: boolean = false;
    dialogVatAssist: boolean = false;
    autoVatDate_ = null;
    autoVatStartDate_ = null;

    newDeclarationStartDate_: string = null;
    newDeclarationEndDate_: string = null;
    depositPeriod: string = null;

    declarationsSelected: any[] = [];
    bundlesSelected: any[] = [];

    companiesSelected = [];
    typesList = [];

    // dialogCreateTaxForm = false;
    dialogCreateTaxForm2 = false;
    search = "";
    type = "ALL";
    status = "ALL";
    selectedYear = "ALL";

    declarationType = "ALL";
    declarationStatus = "ALL";
    bundleType = "ALL";
    bundleStatus = "ALL";

    declarationsPerPage: number = 10;
    declarationsPage: number = 1;
    totalDeclarations: number = 0;

    bundlesPerPage: number = 10;
    bundlesPage: number = 1;
    totalBundles: number = 0;

    prefilter: string = null;
    prefilteredCompanyDeclarationConditions: string[] = [];

    sortBy: string = "asc";

    sortByItems: Array<{ value: string; title: string }> = [
        {
            value: "asc",
            title: "Croissant",
        },
        { value: "desc", title: "Décroissant" },
    ];

    get offerType() {
        return this.$store?.state?.offerType;
    }

    get isUserHasAccess() {
        return this.$store?.getters?.isUserHasAccess();
    }

    get isAllowedToDeclaration() {
        // switch (this.offerType) {
        //     case Offer_type.ACCOUNTING_BASIC:
        //     case Offer_type.ACCOUNTING_ESSENTIAL:
        //     case Offer_type.ACCOUNTING_PREMIUM:
        //     case Offer_type.ACCOUNTING_STARTER:
        //     case Offer_type.BUSINESS_ESSENTIAL:
        //     case Offer_type.BUSINESS_PREMIUM:
        //     case Offer_type.TRAINING:
        //         if (this.isUserHasAccess) {
        //             return true;
        //         }
        //         return false;
        //     default:
        //         return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "declaration",
            "read",
            true,
            "isAllowedToTaxDeclaration",
        );
    }

    get isAllowedToBundles() {
        // switch (this.offerType) {
        //     case Offer_type.ACCOUNTING_BASIC:
        //     case Offer_type.ACCOUNTING_ESSENTIAL:
        //     case Offer_type.ACCOUNTING_PREMIUM:
        //     case Offer_type.ACCOUNTING_STARTER:
        //     case Offer_type.BUSINESS_PREMIUM:
        //     case Offer_type.TRAINING:
        //         if (this.isUserHasAccess) {
        //             return true;
        //         }
        //         return false;
        //     default:
        //         return false;
        // }
        return checkAccessRights(
            this.currentUser,
            "declaration",
            "read",
            true,
            "isAllowedToTaxDeclaration",
        );
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Watch("search")
    @Watch("type")
    @Watch("status")
    resetDeclarationsSelected() {
        this.declarationsSelected = [];
    }

    @Watch("localSelectedWindow")
    resetSelectedCompanies() {
        this.companiesSelected = [];
    }

    @Watch("newDeclarationStep")
    @Watch("newDeclarationStep2")
    resetNewDeclarationData() {
        this.newDeclarationStartDate_ = null;
        this.newDeclarationEndDate_ = null;
        this.depositPeriod = null;
    }

    get isCompanyBNC() {
        return this.selectedCompany?.incomeCategory === "BNC";
    }

    get isDeleteDeclarationDisable() {
        const selectedDeclarationsFull = this.filteredDeclarations.filter((fd) =>
            this.declarationsSelected.includes(fd.id),
        );
        const undeletableDeclarations = selectedDeclarationsFull.filter((sd) => sd.date); // it is the send date
        if (undeletableDeclarations.length || !this.declarationsSelected.length) {
            return true;
        }
        return false;
    }

    mtaeProof(bundleId: string) {
        this.$emit("mtaeProofEvent", bundleId);
    }

    get isDeleteBundleDisable() {
        const selectedBundlesFull = this.filteredBundles.filter((fd) =>
            this.bundlesSelected.includes(fd.id),
        );
        const undeletableBundles = selectedBundlesFull.filter((b) => b.date); // it is the send date
        if (undeletableBundles.length || !this.bundlesSelected.length) {
            return true;
        }
        return false;
    }

    get accountingPeriod() {
        return this.$store?.state?.accountingPeriod?.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod
            : "";
    }

    get accountingPeriodStart() {
        return this.accountingPeriod?.start;
    }

    get accountingPeriodEnd() {
        return this.accountingPeriod?.end;
    }

    get isNewDeclarationDisabled() {
        // if (this.accountingPeriodNeeded) {
        //     return true
        // }
        // if (!this.selectedCompany?.profile?.vatBankAccount || (this.selectedCompany.profile.vatBankAccount && !this.selectedCompany.profile.vatBankAccount.iban)) {
        //     return true
        // }
        // if (this.selectedCompany?.profile?.vatBankAccount && this.selectedCompany.profile.vatBankAccount.iban && !this.selectedCompany.profile.vatBankAccount.bic) {
        //     if (getBICFromIBAN(this.selectedCompany.profile.vatBankAccount.iban)) {
        //         return false
        //     }
        //     return true
        // }
        // if (!this.companyDetails || !this.companyDetails?.address || !this.companyDetails?.city || !this.companyDetails?.name || !this.companyDetails?.postalCode || !this.companyDetails?.profile?.rofs?.length) {
        //     return true
        // }
        return false;
    }

    get accountingPeriodNeeded() {
        if (this.accountingPeriod) {
            return false;
        }
        return true;
    }

    get declarationTypeInformationTable() {
        const storageType = this.declarations.map((dec) => ({
            text: `${dec.cerfaNumber} | ${dec.name}`,
            value: dec.cerfaNumber,
        }));

        storageType.splice(0, 0, { text: "Tout", value: "ALL" });

        return uniqBy(storageType, "value");
    }

    get translateDeclarationStatusTable() {
        const storageStatus = this.declarations.map((dec) => ({
            text: dec.translateStatus,
            value: dec.status,
        }));

        storageStatus.splice(0, 0, { text: "Tout", value: "ALL" });

        return uniqBy(storageStatus, "value");
    }

    get bundleTypeInformationTable() {
        const storageType = this.bundles.map((dec) => ({
            text: `${dec.title}`,
            value: dec.title,
        }));

        storageType.splice(0, 0, { text: "Tout", value: "ALL" });

        return uniqBy(storageType, "value");
    }

    get translateBundleStatusTable() {
        const storageStatus = this.bundles.map((b) => ({
            text: b.translateStatus,
            value: b.status,
        }));

        storageStatus.splice(0, 0, { text: "Tout", value: "ALL" });

        return uniqBy(storageStatus, "value");
    }

    get isInAdmin() {
        const currentLocation = window.location;
        if (currentLocation.pathname === "/admin/tax-forms") {
            return true;
        } else {
            return false;
        }
    }

    get companyId() {
        return this.$store?.state?.selected_company?.id || undefined;
    }

    get selectedCompany() {
        return this.$store?.state?.selected_company;
    }

    // get sortDeclarationsByList() {
    //     return this.declarationsTableHeaders
    //         .filter((x) => x.sortable)
    //         .flatMap((x) => {
    //             return [
    //                 {
    //                     title: x.text + " croissant",
    //                     value: x.value,
    //                     descending: false,
    //                     key: x.value + "_asc",
    //                 },
    //                 {
    //                     title: x.text + " décroissant",
    //                     value: x.value,
    //                     descending: true,
    //                     key: x.value + "_desc",
    //                 },
    //             ];
    //         });
    // }

    // set sortDeclarationsBy(data) {
    //     const [value, desc] = data.split("_");
    //     this.pagination.sortBy = [value];
    //     this.pagination.descending = [desc];
    // }

    // get sortDeclarationsBy() {
    //     if (this.pagination && this.pagination.sortBy && this.pagination.sortBy.length) {
    //         let key = this.pagination.descending[0]
    //             ? this.pagination.sortBy[0] + "_desc"
    //             : this.pagination.sortBy[0] + "_asc";
    //         let head = this.sortDeclarationsByList.find((x) => x.key === key);
    //         // return {
    //         //     key: key,
    //         //     value: this.pagination.sortBy[0],
    //         //     descending: this.pagination.descending[0],
    //         //     text: head.text || ""
    //         // }
    //         return key;
    //     }
    //     return null;
    // }

    // get availableDeclarationForms() {
    //     const eligibleCerfaNumbers = ["1329AC", "1329DEF", "3030SD"];
    //     if (
    //         this.selectedCompany?.vatSystem === "Normal" ||
    //         this.selectedCompany?.vatSystem === "Quartely"
    //     ) {
    //         eligibleCerfaNumbers.push("3310CA3");
    //     }
    //     if (this.selectedCompany?.vatSystem === "Simplified") {
    //         if (this.selectedCompany?.taxSystem === "BA") {
    //             eligibleCerfaNumbers.push("3514SD", "3517BCA12A");
    //         } else {
    //             eligibleCerfaNumbers.push("3514SD", "3517SCA12");
    //         }
    //     }
    //     if (this.selectedCompany?.taxSystemType === "IS") {
    //         eligibleCerfaNumbers.push("2571SD", "2572SD", "2573SD");
    //     }

    //     return this.declarationTypes.filter((dec) =>
    //         eligibleCerfaNumbers.includes(dec.cerfaNumber),
    //     );
    // }

    get availableDeclarationForms2() {
        const availableDeclarationForms2: any[] = [];
        // SPECIFIC
        // 3030
        // add 3030SD (we have bobbee version only)
        if (this.prefilteredCompanyDeclarationConditions[0] === "3030") {
            availableDeclarationForms2.push({
                name: "Examen de conformité fiscale - Compte rendu de mission",
                cerfaNumber: "3030SD",
            });
        } else {
            const eligibleCerfaNumbers: string[] = [];
            for (const companyType of DECLARATIONS_LIST) {
                if (this.prefilteredCompanyDeclarationConditions.includes(companyType.condition)) {
                    for (const declaration of companyType.listDeclaration) {
                        eligibleCerfaNumbers.push(declaration.note.replace("Formulaire ", ""));
                    }
                }
            }
            for (const eligibleCerfaNumber of eligibleCerfaNumbers) {
                const cerfa = this.declarationTypes2.find(
                    (dec) => convertCerfaNumber(dec.cerfaNumber) === eligibleCerfaNumber,
                );
                if (cerfa) {
                    availableDeclarationForms2.push({
                        name: this.transformCerfaName(cerfa.name),
                        cerfaNumber: eligibleCerfaNumber,
                    });
                }
            }
        }
        return availableDeclarationForms2;
    }

    // SPECIFIC
    // 1329AC + 2571 + 3514 + 3525BIS
    // deposit period
    get periodSelectorItems() {
        if (this.selectedDeclarationForm.cerfaNumber === "1329AC") {
            return [
                { text: "Juin", value: "06" },
                { text: "Septembre", value: "09" },
            ];
        }
        if (this.selectedDeclarationForm.cerfaNumber.startsWith("2571")) {
            return [
                { text: "Mars", value: "03" },
                { text: "Juin", value: "06" },
                { text: "Septembre", value: "09" },
                { text: "Décembre", value: "12" },
            ];
        }
        if (this.selectedDeclarationForm.cerfaNumber.startsWith("3514")) {
            return [
                { text: "Juillet", value: "07" },
                { text: "Décembre", value: "12" },
            ];
        }
        if (this.selectedDeclarationForm.cerfaNumber.startsWith("3525BIS")) {
            return [
                { text: "Mai", value: "05" },
                { text: "Août", value: "08" },
                { text: "Novembre", value: "11" },
                { text: "Février", value: "02" },
            ];
        }
        return "XXXX";
    }

    selectedCA3Period: { startDate: string; endDate: string } = null;

    // SPECIFIC
    // 3310CA3
    get CA3Periods(): CA3Period[] {
        const periods: CA3Period[] = [];

        if (
            !this.accountingPeriodStart ||
            this.selectedDeclarationForm?.cerfaNumber !== "3310CA3"
        ) {
            return periods;
        }

        // monthly
        // from accounting period dates for non-calendar fiscal years ("exercices décalés")
        if (this.selectedCompany?.vatSystem === "Normal") {
            const currentCA3PeriodStartDate = moment(this.accountingPeriodStart);
            let isFirstPeriod: boolean = true;
            while (
                currentCA3PeriodStartDate.isSameOrBefore(moment(this.accountingPeriodEnd), "month")
            ) {
                const isLastPeriod: boolean = currentCA3PeriodStartDate
                    .clone()
                    .add(1, "month")
                    .isAfter(moment(this.accountingPeriodEnd));
                periods.push({
                    text: currentCA3PeriodStartDate.format("MMMM YYYY"),
                    value: {
                        startDate: isFirstPeriod // accounting period may start after the first day of the month ("début d'activité")
                            ? currentCA3PeriodStartDate.format("YYYY-MM-DD")
                            : currentCA3PeriodStartDate.startOf("month").format("YYYY-MM-DD"),
                        endDate: isLastPeriod // accounting period may end before the last day of the month ("cessation d'activité")
                            ? moment(this.accountingPeriodEnd).format("YYYY-MM-DD")
                            : currentCA3PeriodStartDate.endOf("month").format("YYYY-MM-DD"),
                    },
                });
                currentCA3PeriodStartDate.add(1, "month");
                isFirstPeriod = false;
            }
        }
        // quarterly
        else if (this.selectedCompany?.vatSystem === "Quartely") {
            const currentCA3PeriodStartDate = moment(this.accountingPeriodStart);
            let isFirstPeriod: boolean = true;
            while (
                currentCA3PeriodStartDate.isSameOrBefore(
                    moment(this.accountingPeriodEnd),
                    "quarter",
                )
            ) {
                const isLastPeriod: boolean = currentCA3PeriodStartDate
                    .clone()
                    .add(1, "quarter")
                    .isAfter(moment(this.accountingPeriodEnd));
                periods.push({
                    text: currentCA3PeriodStartDate.format("[T]Q YYYY"),
                    value: {
                        startDate: isFirstPeriod
                            ? currentCA3PeriodStartDate.format("YYYY-MM-DD")
                            : currentCA3PeriodStartDate.startOf("quarter").format("YYYY-MM-DD"),
                        endDate: isLastPeriod
                            ? moment(this.accountingPeriodEnd).format("YYYY-MM-DD")
                            : currentCA3PeriodStartDate.endOf("quarter").format("YYYY-MM-DD"),
                    },
                });
                currentCA3PeriodStartDate.add(1, "quarter");
                isFirstPeriod = false;
            }
        }

        // select the most recent CA3 period by default
        if (periods?.length) {
            this.selectedCA3Period =
                [...periods].reverse().find((period) => moment().isAfter(period.value.endDate))
                    ?.value || periods?.[0]?.value;
        }
        //

        return periods;
    }

    get tooltipMessage() {
        let message = "";
        if (this.accountingPeriodNeeded) {
            message += `Aucune période sélectionnée`;
        }
        if (
            !this.companyDetails ||
            !this.companyDetails?.address ||
            !this.companyDetails?.city ||
            !this.companyDetails?.name ||
            !this.companyDetails?.postalCode ||
            !this.companyDetails?.profile?.rofs?.length ||
            !this.selectedCompany?.profile?.vatBankAccount ||
            !this.selectedCompany.profile.vatBankAccount.bic ||
            !this.selectedCompany.profile.vatBankAccount.iban
        ) {
            message += `${
                message.length ? " <br/>" : ""
            }Informations manquantes dans le paramétrage du dossier : <br/>
            ${!this.companyDetails?.address ? "- adresse <br/>" : ""}
            ${!this.companyDetails?.city ? "- ville <br/>" : ""}
            ${!this.companyDetails?.postalCode ? "- code postal <br/>" : ""}
            ${!this.companyDetails?.name ? "- nom <br/>" : ""}
            ${
                !this.companyDetails?.profile?.rofs?.length
                    ? "- codes ROFs (Mon dossier -> Configuration -> Télédéclaration) <br/>"
                    : ""
            }
            ${
                !this.selectedCompany?.profile?.vatBankAccount ||
                !this.selectedCompany.profile.vatBankAccount.bic ||
                !this.selectedCompany.profile.vatBankAccount.iban
                    ? "- compte bancaire pour télédéclaration manquant (Mon dossier -> Configuration -> Télédéclaration)"
                    : ""
            }`;
        }
        return message;
    }

    get currentUser(): User {
        return this.$store?.state?.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isAccountingCustomer() {
        return this.currentUser?.profile?.name === "accounting-customer";
    }

    // get filteredDeclarationTypes(): { name: string; cerfaNumber: string }[] {
    //     return orderBy(
    //         this.availableDeclarationForms.filter(
    //             (dec) =>
    //                 dec.name.toLowerCase().includes(this.search.toLowerCase()) ||
    //                 dec.cerfaNumber.toLowerCase().startsWith(this.search.toLowerCase()),
    //         ),
    //         ["cerfaNumber", "name"],
    //         ["asc", "asc"],
    //     );
    // }

    get sortedDeclarationTypes2(): { name: string; cerfaNumber: string }[] {
        return orderBy(this.availableDeclarationForms2, ["cerfaNumber", "name"], ["asc", "asc"]);
    }

    get filteredDeclarations(): Declaration[] {
        let result: Declaration[] = this.declarations;
        //Filtre par type
        if (this.declarationType !== "ALL") {
            result = result.filter((dec) => this.declarationType.includes(dec.cerfaNumber));
        }
        //Filtre par société
        if (this.companiesSelected.length > 0) {
            result = result.filter((dec) =>
                this.companiesSelected.map((x) => x.id).includes(dec.company.id),
            );
        }
        //Filtre par statut
        if (this.declarationStatus !== "ALL") {
            result = result.filter((dec) => this.declarationStatus.includes(dec.status));
        }
        //filtre par année
        if (this.selectedYear !== "ALL") {
            result = result.filter((dec) => this.selectedYear.includes(dec.year));
        }
        return result;
    }

    get sortedDeclarations(): Declaration[] {
        if (this.sortBy === "asc") {
            return (
                this.filteredDeclarations?.slice().sort(function (a, b) {
                    return a.date?.localeCompare(b.date);
                }) || this.filteredDeclarations
            );
        } else {
            return (
                this.filteredDeclarations?.slice().sort(function (a, b) {
                    return b.date?.localeCompare(a.date);
                }) || this.filteredDeclarations
            );
        }
    }

    get filteredBundles() {
        // let result = [...this.declarations]
        let result = this.bundles;
        //Filtre par type
        if (this.bundleType !== "ALL") {
            result = result.filter((b) => this.bundleType === b.title);
        }
        //Filtre par société
        if (this.companiesSelected.length > 0) {
            result = result.filter((b) =>
                this.companiesSelected.map((x) => x.id).includes(b.company.id),
            );
        }
        //Filtre par statut
        if (this.bundleStatus !== "ALL") {
            result = result.filter((b) => this.bundleStatus.includes(b.status));
        }
        //filtre par année
        if (this.selectedYear !== "ALL") {
            result = result.filter((b) => this.selectedYear.includes(b.year));
        }
        // show accepted bundles only for accounting-customer profiles ("Client du cabinet - Comptable")
        if (this.isAccountingCustomer) {
            result = result.filter((b) => b.mtaeStatus === "Déclaration acceptée");
        }
        return result;
    }

    get newDeclarationStartDate() {
        if (this.newDeclarationStartDate_) {
            return this.newDeclarationStartDate_;
        }
        // SPECIFIC
        if (
            ["1329AC", "2571", "2571SD", "3514", "3514SD", "3525BIS"].includes(
                this.selectedDeclarationForm.cerfaNumber,
            )
        ) {
            if (this.depositPeriod) {
                return this.getDepositDate();
            }
        }
        if (this.selectedDeclarationForm.cerfaNumber === "DAS2") {
            const today = new Date();
            const yearN1 = today.getFullYear() - 1;
            const firstJanN1 = new Date(yearN1, 0, 1);
            return moment(firstJanN1).format("YYYY-MM-DD");
        }
        if (
            [
                "3517SCA12",
                "3517BCA12",
                "2572",
                "2572SD",
                "1329DEF",
                "3030SD",
                "2573",
                "2573SD",
            ].includes(this.selectedDeclarationForm.cerfaNumber)
        ) {
            return moment(this.accountingPeriod.start).format("YYYY-MM-DD");
        }
        if (["3310CA3"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            return this.selectedCA3Period?.startDate;
        }
        if (["2777", "3519", "3517DDR"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            if (this.selectedCompany?.vatSystem === "Quartely") {
                return moment().subtract(1, "quarter").startOf("quarter").format("YYYY-MM-DD");
            }
            return moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD");
        }
        if (["2561"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            return moment(this.getFirstJanuaryLastYear()).format("YYYY-MM-DD");
        }
        return null;
    }

    set newDeclarationStartDate(data) {
        this.newDeclarationStartDate_ = data;
    }

    get newDeclarationEndDate() {
        if (this.newDeclarationEndDate_) {
            return this.newDeclarationEndDate_;
        }
        // SPECIFIC
        if (
            ["1329AC", "2571", "2571SD", "3514", "3514SD", "3525BIS"].includes(
                this.selectedDeclarationForm.cerfaNumber,
            )
        ) {
            if (this.depositPeriod) {
                return this.getDepositDate();
            }
        }
        if (this.selectedDeclarationForm.cerfaNumber === "DAS2") {
            const today = new Date();
            const yearN1 = today.getFullYear() - 1;
            const lastDecN1 = new Date(yearN1, 11, 31);
            return moment(lastDecN1).format("YYYY-MM-DD");
        }
        if (
            [
                "3517SCA12",
                "3517BCA12",
                "2572",
                "2572SD",
                "1329DEF",
                "3030SD",
                "2573",
                "2573SD",
            ].includes(this.selectedDeclarationForm.cerfaNumber)
        ) {
            return moment(this.accountingPeriod.end).format("YYYY-MM-DD");
        }
        if (["3310CA3"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            return this.selectedCA3Period?.endDate;
        }
        if (["2777", "3519", "3517DDR"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            if (this.selectedCompany?.vatSystem === "Quartely") {
                return moment().subtract(1, "quarter").endOf("quarter").format();
            }
            return moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD");
        }
        if (["2561"].includes(this.selectedDeclarationForm.cerfaNumber)) {
            return moment(this.getLastDecemberLastYear()).format("YYYY-MM-DD");
        }
        return null;
    }

    set newDeclarationEndDate(data) {
        this.newDeclarationEndDate_ = data;
    }

    get disableNewBundleCreation() {
        if (!this.selectedCompany) {
            return true;
        }
        // if (this.selectedCompany.legalForm === 'SCI' && this.selectedCompany.taxSystem === 'RF') {
        //     if (env.environnement === 'production') {
        //         return true;
        //     }
        // }
        return false;
    }

    get autoVatDate() {
        if (this.autoVatDate_) {
            return this.autoVatDate_;
        }
        if (this.selectedCompany?.vatSystem === "Quartely") {
            return moment().subtract(1, "quarter").endOf("quarter").format();
        }
        return moment().subtract(1, "months").endOf("month").format();
    }

    set autoVatDate(data) {
        this.autoVatDate_ = data;
    }

    get autoVatStartDate() {
        if (this.autoVatStartDate_) {
            return this.autoVatStartDate_;
        }
        if (this.selectedCompany?.vatSystem === "Quartely" && this.autoVatDate) {
            return moment(this.autoVatDate).startOf("quarter").format();
        }
        return moment(this.autoVatDate).startOf("month").format();
    }

    set autoVatStartDate(data) {
        this.autoVatStartDate_ = data;
    }

    get isVatAssistValidDisabled() {
        if (!this.autoVatStartDate || !this.autoVatDate) {
            return true;
        }
        if (moment(this.autoVatDate).isBefore(this.autoVatStartDate)) {
            return true;
        }
        if (moment(this.autoVatDate).diff(this.autoVatStartDate, "months") > 3) {
            return true;
        }
        return false;
    }

    get isNewDeclarationDialogValidDisabled() {
        // no dates
        if (
            this.newDeclarationStep === "declarationDatesSelection" ||
            this.newDeclarationStep2 === "declarationDatesSelection"
        ) {
            if (
                !this.depositPeriod &&
                !this.newDeclarationStartDate &&
                !this.newDeclarationEndDate
            ) {
                return true;
            }
        }
        // auto vat
        if (
            (this.newDeclarationStep === "vatAutoDatesSelection" ||
                this.newDeclarationStep2 === "vatAutoDatesSelection") &&
            (!this.newDeclarationEndDate || !this.companyId)
        ) {
            return true;
        }
        // assist vat
        if (
            (this.newDeclarationStep === "vatAssistDatesSelection" ||
                this.newDeclarationStep2 === "vatAssistDatesSelection") &&
            (!this.newDeclarationStartDate || !this.newDeclarationEndDate || !this.companyId)
        ) {
            return true;
        }
        // SPECIFIC
        // 3310CA3
        // adapt date checks for straddling quarters ("trimestres à cheval sur plusieurs exercices")
        if (
            this.selectedDeclarationForm?.cerfaNumber === "3310CA3" &&
            this.selectedCompany?.vatSystem === "Quartely"
        ) {
            if (
                this.selectedCA3Period?.startDate < this.accountingPeriodStart &&
                this.selectedCA3Period?.endDate > this.accountingPeriodStart
            ) {
                return false;
            }
            if (
                this.selectedCA3Period?.endDate > this.accountingPeriodEnd &&
                this.selectedCA3Period?.startDate < this.accountingPeriodEnd
            ) {
                return false;
            }
        }
        // SPECIFIC
        // DAS2
        // do not check, dates are automatially set from today's year
        if (this.selectedDeclarationForm?.cerfaNumber === "DAS2") {
            return false;
        }
        // general case
        if (
            new Date(this.newDeclarationStartDate) < new Date(this.accountingPeriodStart) ||
            new Date(this.newDeclarationStartDate) > new Date(this.accountingPeriodEnd) ||
            new Date(this.newDeclarationEndDate) < new Date(this.accountingPeriodStart) ||
            new Date(this.newDeclarationEndDate) > new Date(this.accountingPeriodEnd)
        ) {
            return true;
        }
        return false;
    }

    get bundlesTableHeaders(): {
        title: string;
        value: string;
        sortable: boolean;
        align: "start" | "center" | "end";
        width: string;
    }[] {
        if (this.isInAdmin) {
            return [
                { title: "", value: "checkbox", sortable: false, align: "start", width: "5%" },
                {
                    title: "Société",
                    value: "company.name",
                    sortable: true,
                    align: "start",
                    width: "15%",
                },
                { title: "Type", value: "type", sortable: false, align: "center", width: "15%" },
                { title: "Régime", value: "scheme", sortable: false, align: "center", width: "5%" },
                { title: "Exercice", value: "", sortable: false, align: "center", width: "15%" },
                {
                    title: "Statut",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    title: "Date d'envoi",
                    value: "sendDate",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Date de création",
                    value: "createdAt",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Date de dernière modification",
                    value: "updatedAt",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Justificatif EDI",
                    value: "mtaeProof",
                    sortable: false,
                    align: "center",
                    width: "8%",
                },
            ];
        } else {
            return [
                { title: "", value: "checkbox", sortable: false, align: "start", width: "5%" },
                { title: "Type", value: "type", sortable: false, align: "start", width: "20%" },
                {
                    title: "Régime",
                    value: "scheme",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                { title: "Exercice", value: "", sortable: false, align: "center", width: "15%" },
                {
                    title: "Statut",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    title: "Date d'envoi",
                    value: "sendDate",
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    title: "Date de création",
                    value: "createdAt",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Date de dernière modification",
                    value: "updatedAt",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Justificatif EDI",
                    value: "mtaeProof",
                    sortable: false,
                    align: "center",
                    width: "8%",
                },
            ];
        }
    }

    get declarationsTableHeaders(): {
        title: string;
        value: string;
        sortable: boolean;
        align: "start" | "center" | "end";
        width: string;
    }[] {
        if (this.isInAdmin) {
            return [
                { title: "", value: "checkbox", sortable: false, align: "start", width: "5%" },
                {
                    title: "Société",
                    value: "company.name",
                    sortable: false,
                    align: "start",
                    width: "20%",
                },
                {
                    title: "CERFA",
                    value: "cerfaNumber",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                { title: "Nom", value: "name", sortable: false, align: "center", width: "17%" },
                {
                    title: "Période",
                    value: "period",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Millésime",
                    value: "millesime",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Montant déclaré",
                    value: "totalAmounts",
                    sortable: false,
                    align: "end",
                    width: "5%",
                },
                {
                    title: "Montant payé",
                    value: "totalAmounts",
                    sortable: false,
                    align: "end",
                    width: "5%",
                },
                {
                    title: "Statut",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: "25%",
                },
                {
                    title: "Date de déclaration",
                    value: "declarationDate",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Date de création",
                    value: "createdAt",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Date de dernière modification",
                    value: "updatedAt",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Justificatif EDI",
                    value: "mtaeProof",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
            ];
        } else {
            return [
                { title: "", value: "checkbox", sortable: false, align: "start", width: "5%" },
                {
                    title: "CERFA",
                    value: "cerfaNumber",
                    sortable: false,
                    align: "start",
                    width: "10%",
                },
                { title: "Nom", value: "name", sortable: false, align: "center", width: "27%" },
                {
                    title: "Période",
                    value: "period",
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    title: "Millésime",
                    value: "millesime",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
                {
                    title: "Montant déclaré",
                    value: "totalAmounts",
                    sortable: false,
                    align: "end",
                    width: "5%",
                },
                {
                    title: "Montant payé",
                    value: "totalAmounts",
                    sortable: false,
                    align: "end",
                    width: "5%",
                },
                {
                    title: "Statut",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: "25%",
                },
                {
                    title: "Date de déclaration",
                    value: "declarationDate",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Date de création",
                    value: "createdAt",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Date de dernière modification",
                    value: "updatedAt",
                    sortable: false,
                    align: "center",
                    width: "5%",
                },
                {
                    title: "Justificatif EDI",
                    value: "mtaeProof",
                    sortable: false,
                    align: "center",
                    width: "10%",
                },
            ];
        }
    }

    // SPECIFIC
    // conditions
    get companyDeclarationConditions(): string[] {
        // conditions for all companies
        const conditions = [
            "isCVAESubject",
            "isTSSubject",
            "isTenant",
            "isRCMSubject",
            "isIFUSubject",
            "isDAS2Subject",
            "3030",
        ];

        // TVA condition
        if (
            this.selectedCompany?.vatSystem === "Normal" ||
            this.selectedCompany?.vatSystem === "Quartely"
        ) {
            conditions.push("isTvaRegimeReel");
        } else if (this.selectedCompany?.vatSystem === "Simplified") {
            if (this.selectedCompany?.incomeCategory === "BA") {
                conditions.push("isTvaRegimeAgricole");
            } else {
                conditions.push("isTvaRegimeSimplifie");
            }
        }

        // IS condition
        if (this.selectedCompany?.taxSystemType === "IS") {
            conditions.push("isRegimeFiscalIS");
        }
        return conditions;
    }

    emptyFunction() {}

    selectDeclaration(declarationId) {
        if (this.declarationsSelected.includes(declarationId)) {
            this.declarationsSelected = this.declarationsSelected.filter(
                (decId) => decId !== declarationId,
            );
        } else {
            this.declarationsSelected.push(declarationId);
        }
    }
    
    selectBundle(bundleId) {
        if (this.bundlesSelected.includes(bundleId)) {
            this.bundlesSelected = this.bundlesSelected.filter((decId) => decId !== bundleId);
        } else {
            this.bundlesSelected.push(bundleId);
        }
    }

    @Apollo({
        query: DECLARATIONS_FORM_LIST,
        variables() {
            return {
                type: "VERSION2",
            };
        },
        skip() {
            return this.isInAdmin;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarationsFormList?.length) {
                    // this.declarationTypes = data.declarationsFormList.filter(
                    //     (form) => form.type === "VERSION1",
                    // );
                    // this.declarationTypes2 = data.declarationsFormList.filter(
                    //     (form) => form.type === "VERSION2",
                    // );
                    this.declarationTypes2 = data.declarationsFormList;
                }
            }
        },
    })
    // declarationTypes: any = [];
    declarationTypes2: any = [];

    @Apollo({
        query: DECLARATIONS,
        variables() {
            if (!this.isInAdmin) {
                return {
                    where: {
                        company: { id: this.companyId },
                        type: "DECLARATION",
                        accountingPeriod: { id: this.accountingPeriod.id },
                    },
                    take: this.declarationsPerPage,
                    skip: (this.declarationsPage - 1) * this.declarationsPerPage,
                };
            }
            return {
                where: {
                    company: { id_in: this.allAvailableCompanies.map((x) => x.id) },
                    type: "DECLARATION",
                    isBundleSheetOf: null,
                    isSheetOf: null,
                },
                take: this.declarationsPerPage,
                skip: (this.declarationsPage - 1) * this.declarationsPerPage,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.isInAdmin && (!this.companyId || !this.accountingPeriod);
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarations) {
                    const declarations: Declaration[] = [];
                    for (const dbDeclaration of data.declarations) {
                        const declaration = Object.assign(new Declaration(), dbDeclaration, {});
                        declarations.push(declaration);
                    }
                    this.declarations = declarations;
                }
                if (data?.declarationsConnection) {
                    this.totalDeclarations = data.declarationsConnection.aggregate.count;
                }
            }
        },
    })
    declarations: Declaration[] = [];

    @Apollo({
        query: DECLARATIONS,
        variables() {
            if (!this.isInAdmin) {
                return {
                    where: {
                        type: "BUNDLE",
                        company: { id: this.companyId },
                        accountingPeriod: { id: this.accountingPeriod.id },
                    },
                    take: this.bundlesPerPage,
                    skip: (this.bundlesPage - 1) * this.bundlesPerPage,
                };
            }
            return {
                where: {
                    company: { id_in: this.allAvailableCompanies.map((x) => x.id) },
                    type: "BUNDLE",
                },
                take: this.bundlesPerPage,
                skip: (this.bundlesPage - 1) * this.bundlesPerPage,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.isInAdmin && (!this.companyId || !this.accountingPeriod);
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarations) {
                    const bundles: Declaration[] = [];
                    for (const dbDeclaration of data.declarations) {
                        const declaration = Object.assign(new Declaration(), dbDeclaration, {});
                        bundles.push(declaration);
                    }
                    this.bundles = bundles;
                    this.bundlesSelected = [];
                }
                if (data?.declarationsConnection) {
                    this.totalBundles = data.declarationsConnection.aggregate.count;
                }
            }
        },
    })
    bundles: Declaration[] = [];

    get allAvailableCompanies() {
        return this.$store?.state?.user?.allAvailableCompanies;
    }

    get availableCompaniesId() {
        return this.allAvailableCompanies.map((x) => x.id);
    }

    @Apollo({
        query: COMPANIES,
        variables() {
            const where = {
                id_in: this.availableCompaniesId,
                activities_some: undefined,
                legalForm_in: undefined,
            };
            return { where: where };
        },
        skip() {
            return !this.availableCompaniesId.length;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.companies = data.companies;
                } else {
                    this.companies = [];
                }
            }
        },
    })
    companies = [];

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    address
                    postalCode
                    city
                    profile {
                        id
                        rofs
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId || this.isInAdmin;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.company) {
                    this.companyDetails = data.company;
                }
            }
        },
    })
    companyDetails: any = {
        name: "",
        address: "",
        postatCode: "",
        city: "",
        profile: {
            rofs: [],
        },
    };

    resetSelectedDeclarationForm() {
        this.selectedDeclarationForm = {
            id: "",
            cerfaNumber: "",
            name: "",
            type: "",
        };
    }

    // declarationRoute(value) {
    //     this.$router.push({ name: value });
    // }

    // newDeclarationRoute() {
    //     this.$router.push({
    //         name: "declaration-new",
    //         params: {
    //             cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
    //             propsStartDate: this.newDeclarationStartDate,
    //             propsEndDate: this.newDeclarationEndDate,
    //             accountingPeriodId: this.accountingPeriod.id,
    //         },
    //     });
    // }

    newDeclarationRoute2() {
        // if (this.selectedDeclarationForm.cerfaNumber === "3030SD") {
        //     this.$router.push({
        //         name: "declaration-new",
        //         params: {
        //             cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
        //             propsStartDate: this.newDeclarationStartDate,
        //             propsEndDate: this.newDeclarationEndDate,
        //             accountingPeriodId: this.accountingPeriod.id,
        //         },
        //     });
        // } else {
        this.$router.push({
            name: "declaration2-new",
            params: {
                propsCerfaNumber: this.selectedDeclarationForm.cerfaNumber,
                propsStartDate: this.formatDateWithDash(this.newDeclarationStartDate),
                propsEndDate: this.formatDateWithDash(this.newDeclarationEndDate),
            },
        });
        // }
    }

    formatDate(date) {
        return moment(date).format("DD MMM YYYY");
    }

    formatDateWithSlash(date) {
        return moment(date).format("DD/MM/YYYY");
    }

    formatDateWithDash(date) {
        return moment(date).format("YYYY-MM-DD");
    }

    getDepositDate() {
        let incrementedDate = moment(this.accountingPeriod.start).clone();
        while (moment(incrementedDate).isSameOrBefore(this.accountingPeriod.end)) {
            const month = moment(incrementedDate).format("DD/MM/YYYY").substring(3, 5);
            if (month === this.depositPeriod) {
                // SPECIFIC
                // 3525BIS
                // deposit date
                if (this.selectedDeclarationForm?.cerfaNumber === "3525BIS") {
                    return moment(incrementedDate).format("YYYY-MM") + "-5";
                }
                return moment(incrementedDate).format("YYYY-MM") + "-15";
            }
            incrementedDate = incrementedDate.add(1, "months");
        }
    }

    get existingBundlesForAccPer() {
        const bundles = this.bundles.filter(
            (bundle) => bundle.accountingPeriod.id === this.accountingPeriod.id,
        );
        return bundles;
    }

    newBundleAction() {
        // if (!this.isCompanyBNC) {
        //     this.bundleInformationDialog = true
        // } else {
        if (this.existingBundlesForAccPer.length) {
            this.manyBundlesOnSamePeriodDialog = true;
        } else {
            this.newBundle();
        }
        // }
    }

    selectAllDeclarations() {
        if (
            !this.declarationsSelected?.length ||
            this.declarationsSelected.length !== this.filteredDeclarations.length
        ) {
            this.declarationsSelected = this.filteredDeclarations.map((dec) => dec.id);
        } else {
            this.declarationsSelected = [];
        }
    }

    selectAllBundles() {
        if (
            !this.bundlesSelected?.length ||
            this.bundlesSelected.length !== this.filteredBundles.length
        ) {
            this.bundlesSelected = this.filteredBundles.map((b) => b.id);
        } else {
            this.bundlesSelected = [];
        }
    }

    async deleteDeclarations() {
        const promises = [];
        for (const id of this.declarationsSelected) {
            promises.push(
                this.$apollo.mutate({
                    mutation: DELETE_DECLARATION,
                    variables: {
                        id,
                    },
                }),
            );
        }
        try {
            await Promise.all(promises);
            this.declarations = this.declarations.filter(
                (dec) => !this.declarationsSelected.includes(dec.id),
            );
            this.declarationsSelected = [];
        } catch (e) {
            console.error("Error while deleting declarations");
        }
        this.dialogDeleteSelectedDeclaration = false;
    }

    async deleteBundles() {
        try {
            const promises = [];
            if (this.bundlesSelected?.length) {
                for (const id of this.bundlesSelected) {
                    promises.push(
                        this.$apollo.mutate({
                            mutation: DELETE_BUNDLE,
                            variables: {
                                bundleId: id,
                            },
                        }),
                    );
                }
                const ids = await Promise.all(promises);
                if (ids.length) {
                    this.bundles = this.bundles.filter(
                        (bundle) => !this.bundlesSelected.includes(bundle.id),
                    );
                    this.bundlesSelected = [];
                }
            }
        } catch (e) {
            console.error("Error while deleting bundles");
        }
        this.dialogDeleteSelectedBundles = false;
    }

    // openTaxFormCreateDialog() {
    //     this.dialogCreateTaxForm = true;
    // }

    openTaxFormCreateDialog2() {
        this.dialogCreateTaxForm2 = true;
    }

    openVatAssistDialog() {
        this.dialogVatAssist = true;
    }

    // resetNewDeclarationDialog() {
    //     this.newDeclarationStep = "declarationSelection";
    //     this.resetSelectedDeclarationForm();
    // }

    resetNewDeclarationDialog2() {
        this.newDeclarationStep2 = "prefilterSelection";
        this.resetSelectedDeclarationForm();
    }

    // validNewDeclarationDialog() {
    //     if (this.newDeclarationStep === "declarationDatesSelection") {
    //         return this.newDeclarationRoute();
    //     } else if (this.newDeclarationStep === "vatAutoDatesSelection") {
    //         return this.$router.push({
    //             name: "vatDeclarationAuto",
    //             params: {
    //                 startDate: this.newDeclarationStartDate,
    //                 endDate: this.newDeclarationEndDate,
    //                 companyId: this.companyId,
    //                 cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
    //                 version: "old",
    //             },
    //         });
    //     } else if (this.newDeclarationStep === "vatAssistDatesSelection") {
    //         return this.$router.push({
    //             name: "vatCalculationAssist",
    //             params: {
    //                 startDate: this.newDeclarationStartDate,
    //                 endDate: this.newDeclarationEndDate,
    //                 companyId: this.companyId,
    //                 cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
    //                 version: "old",
    //             },
    //         });
    //     }
    // }

    validNewDeclarationDialog2() {
        if (this.newDeclarationStep2 === "declarationDatesSelection") {
            if (this.selectedDeclarationForm.cerfaNumber === "DAS2") {
                return this.$router.push({
                    name: "dasTwo",
                    params: {
                        companyId: this.companyId,
                        cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
                        startDate: this.formatDateWithDash(this.newDeclarationStartDate),
                        endDate: this.formatDateWithDash(this.newDeclarationEndDate),
                    },
                });
            }
            return this.newDeclarationRoute2();
        } else if (this.newDeclarationStep2 === "vatAutoDatesSelection") {
            // empty store for a new auto vat
            this.$store?.commit("resetVatItems");
            return this.$router.push({
                name: "vatDeclarationAuto",
                params: {
                    startDate: this.formatDateWithDash(this.newDeclarationStartDate),
                    endDate: this.formatDateWithDash(this.newDeclarationEndDate),
                    companyId: this.companyId,
                    cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
                    version: "new",
                },
            });
        } else if (this.newDeclarationStep2 === "vatAssistDatesSelection") {
            // empty store for a new assist vat
            this.$store?.commit("resetVatItems");
            return this.$router.push({
                name: "vatCalculationAssist",
                params: {
                    startDate: this.formatDateWithDash(this.newDeclarationStartDate),
                    endDate: this.formatDateWithDash(this.newDeclarationEndDate),
                    companyId: this.companyId,
                    cerfaNumber: this.selectedDeclarationForm.cerfaNumber,
                    version: "new",
                },
            });
        }
    }

    toggleBundleInformationDialog() {
        this.bundleInformationDialog = !this.bundleInformationDialog;
    }

    newBundle() {
        this.$router.push({
            name: "taxForm2-new",
        });
    }

    async openDeclaration(declaration: Declaration) {
        if (this.isInAdmin) {
            if (!declaration.company?.id) {
                debugger;
                return;
            }
            const selectedCompany = this.allAvailableCompanies.find(
                (x) => x.id === declaration.company.id,
            );
            await setCurrentCompany(this.$apollo, this.$store, selectedCompany, undefined, true);
        }
        declaration.open(this.$router, this.formatDateWithDash, this.$store);
    }

    transformCerfaName(str: string) {
        return (
            str
                ?.replace(/^.*?:\s*/, "")
                .replace(/\s*\(.*?\)\s*/g, "")
                .trim() || "XXXX"
        );
    }

    getFirstJanuaryLastYear() {
        const currentDate = new Date();
        const lastYear = currentDate.getFullYear() - 1;
        return new Date(lastYear, 0, 1);
    }

    getLastDecemberLastYear() {
        const currentDate = new Date();
        const lastYear = currentDate.getFullYear() - 1;
        return new Date(lastYear, 11, 31);
    }

    beforeMount() {
        this.localSelectedWindow = this.selectedWindow;
    }

    prefilterForms(condition: string) {
        this.prefilter = condition;
        switch (condition) {
            case "Tva":
                this.prefilteredCompanyDeclarationConditions =
                    this.companyDeclarationConditions.filter((cd) => cd.includes("Tva"));
                break;
            default:
                this.prefilteredCompanyDeclarationConditions =
                    this.companyDeclarationConditions.filter((cd) => cd === condition);
                break;
        }
        if (this.sortedDeclarationTypes2.length === 1) {
            this.selectedDeclarationForm = this.sortedDeclarationTypes2[0];
            this.newDeclarationStep2 = "declarationDatesSelection";
        } else {
            this.newDeclarationStep2 = "declarationSelection";
        }
    }

    goToPreviousTab() {
        if (
            this.newDeclarationStep2 === "declarationSelection" ||
            this.sortedDeclarationTypes2.length === 1
        ) {
            this.newDeclarationStep2 = "prefilterSelection";
        } else {
            this.newDeclarationStep2 = "declarationSelection";
        }
        this.resetSelectedDeclarationForm();
    }
}

type CA3Period = { text: string; value: { startDate: string; endDate: string } };

export default toNative(TaxFormList);
</script>

<style scoped>
.wrapper {
    white-space: normal;
}

.v-tab-rounded-0,
.v-tab-rounded-0:hover {
    border-radius: 0px !important;
}
</style>
